<!-- In App.vue -->
<template>
  <div id="app">
    <!-- Navbar should be visible on all pages except login -->
    <Navbar v-if="!isLoginPage" />
    
    <main :class="{'container py-4': !isLoginPage}">
      <router-view />
    </main>
    
    <!-- Footer -->
    <footer v-if="!isLoginPage" class="bg-light mt-5 py-3 border-top">
      <div class="container text-center text-muted">
        <p class="mb-0">© {{ currentYear }} Katherine Luzuriaga Ortodoncia. Todos los derechos reservados.</p>
      </div>
    </footer>

    <Notifications />
  </div>
</template>

<!-- Update script section: -->
<script>

import Navbar from '@/components/layout/Navbar.vue';
import Notifications from '@/components/layout/Notifications.vue';
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    Navbar,
    Notifications,
  },
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.isAuthenticated
    }),
    isLoginPage() {
      return this.$route.path === '/login';
    }
  },
  created() {
    // Check authentication status when app starts
    this.$store.dispatch('checkAuth');
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/main.scss';

/* Additional global styles */
body {
  font-family: 'Nunito', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}
</style>